import { forwardRef, type Ref, type SVGProps } from "react";
const IconUserSettingsOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M11.736 4.779A6 6 0 0 1 16 3a6 6 0 0 1 5.966 6.06v1.269a8.36 8.36 0 0 1-2.863 6c.488.111.96.248 1.414.394a.857.857 0 1 1-.531 1.628 16.6 16.6 0 0 0-5.143-.78c-5.383 0-9.129 2.22-9.129 4.218v3.497h9.429a.857.857 0 0 1 0 1.714H5.714A1.714 1.714 0 0 1 4 25.286v-3.497c0-2.88 3.566-5.212 8.469-5.795A8.3 8.3 0 0 1 10 10.286V9.06a6 6 0 0 1 1.736-4.281m7.161 9.364a6.67 6.67 0 0 0 1.389-3.857V9.06a4.286 4.286 0 1 0-8.572-.009v1.235c0 2.511 1.98 5.571 4.286 5.571a3.88 3.88 0 0 0 2.897-1.714"
        fill="currentColor"
      />
      <path
        d="M23.601 19h.798l.216 1.08.084.144a2.41 2.41 0 0 0 2.108 1.182h.1l1.384-.296.463.773-.771.82-.054.087a2.3 2.3 0 0 0 0 2.42l.054.087.77.82-.462.773-1.384-.295-.1-.001a2.41 2.41 0 0 0-2.108 1.182l-.084.144-.216 1.08H23.6l-.216-1.08-.084-.144a2.4 2.4 0 0 0-2.108-1.182h-.1l-1.384.296-.463-.773.771-.82.054-.087a2.31 2.31 0 0 0 0-2.42l-.054-.087-.77-.82.462-.773 1.384.295.1.001c.857.01 1.67-.432 2.108-1.182l.084-.144zm-1.164.72.345-1.72h2.436l.345 1.72a1.4 1.4 0 0 0 .52.506c.212.119.458.183.714.18l1.985-.423L30 22.017l-1.218 1.296c-.26.424-.26.95 0 1.374L30 25.983l-1.218 2.034-1.985-.423a1.41 1.41 0 0 0-1.234.686L25.218 30h-2.436l-.345-1.72a1.41 1.41 0 0 0-1.234-.686l-1.985.423L18 25.983l1.218-1.296c.26-.424.26-.95 0-1.374L18 22.017l1.218-2.034 1.985.423c.512.006.984-.258 1.234-.686M26 24a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
        fill="currentColor"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(IconUserSettingsOutlineSVG);
ForwardRef.displayName = "IconUserSettingsOutline";
export { ForwardRef as IconUserSettingsOutline };
